class MultiStepForm {
    constructor({ formContainer }) {
        this.formContainer = formContainer;
        this.stepElements = [...this.formContainer.querySelectorAll('.js-multi-step-form-step')];
        this.progressElements = [...this.formContainer.querySelectorAll('.progress-bar')];

        // state
        this.currentStep = 0;
        this.prevStep = this.currentStep;
        this.lastStep = Math.max(
            ...this.stepElements.map((el) => Number(el.dataset.step)).filter((el) => el > 0)
        );

        this.#changeStepListener();

        this.go(1);
    }

    go(step) {
        const parsedStep = Number(step);
        this.prevStep = this.currentStep;

        if (parsedStep <= 0) {
            console.error(`Could not change step to: ${step}`);
            return;
        }

        if (parsedStep === this.currentStep) {
            return;
        }

        const validation = this.#validate(parsedStep);

        if (!validation.status) {
            this.currentStep = validation.failedStep;
            if (this.currentStep !== this.prevStep) {
                this.#onStepChange();
            }
            this.#reportStepValidation(validation.failedStep);
            return;
        }

        if (parsedStep > this.lastStep) {
            this.formContainer.dispatchEvent(
                new Event('submit', { bubbles: true, cancelable: true })
            );
            // this.formContainer.submit();
            return;
        }

        this.currentStep = parsedStep;
        this.#onStepChange();
    }

    #onStepChange() {
        this.stepElements.forEach((el) => el.classList.remove('is-active'));
        this.stepElements
            .filter((el) => Number(el.dataset.step) === Number(this.currentStep))
            .forEach((el) => {
                el.classList.add('is-active');
            });

        this.progressElements.forEach((el) => {
            el.style.width = `${(this.currentStep / this.lastStep) * 100}%`;
        });

        this.formContainer.dispatchEvent(
            new CustomEvent('multi-step-form.step.changed', {
                detail: {
                    currentStep: this.currentStep,
                    prevStep: this.prevStep,
                    lastStep: this.lastStep,
                    form: this.formContainer,
                },
            })
        );

        const datalayerContent = this.formContainer.getAttribute('datalayer-steps');

        if (datalayerContent) {
            window.dispatchEvent(
                new CustomEvent('datalayer.form_step', {
                    detail: {
                        currentStep: this.currentStep,
                        datalayer: JSON.parse(datalayerContent),
                    },
                })
            );
        }
    }

    #changeStepListener() {
        const changeStepElements = [
            ...document.querySelectorAll('.js-multi-step-form-change-step'),
        ].filter((el) => !el.multiStepFormInitialized);
        const nextStepElements = [
            ...document.querySelectorAll('.js-multi-step-form-next-step'),
        ].filter((el) => !el.multiStepFormInitialized);
        const prevStepElements = [
            ...document.querySelectorAll('.js-multi-step-form-prev-step'),
        ].filter((el) => !el.multiStepFormInitialized);

        changeStepElements.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.go(Number(el.dataset.step));
            });
            el.dataset.multiStepFormInitialized = true;
        });

        nextStepElements.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.go(this.currentStep + 1);
            });
            el.dataset.multiStepFormInitialized = true;
        });

        prevStepElements.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                this.go(this.currentStep - 1);
            });
            el.dataset.multiStepFormInitialized = true;
        });
    }

    #validateStep(step) {
        const currentStepInputs = this.stepElements
            .filter((el) => Number(el.dataset.step) === Number(step))
            .reduce(
                (acc, currentStepElement) => [
                    ...acc,
                    ...currentStepElement.querySelectorAll('input, select, textarea'),
                ],
                []
            );

        return currentStepInputs.every((el) => el.checkValidity());
    }

    #reportStepValidation(step) {
        const currentStepInputs = this.stepElements
            .filter((el) => Number(el.dataset.step) === Number(step))
            .reduce(
                (acc, currentStepElement) => [
                    ...acc,
                    ...currentStepElement.querySelectorAll('input, select, textarea'),
                ],
                []
            );

        return currentStepInputs.every((el) => el.reportValidity());
    }

    #validate(changeToStep) {
        if (changeToStep <= this.currentStep) {
            return { status: true };
        }

        for (let i = this.currentStep; i < changeToStep; i += 1) {
            if (!this.#validateStep(i)) {
                return { status: false, failedStep: i };
            }
        }

        return { status: true };
    }
}

export default MultiStepForm;
